import classNames from "classnames";
import { Image } from "antd";

import styles from "./Recruiter.mobile.module.scss";

const Recruiter = ({ data }) => {
  return (
    <div className={styles.recruiter}>
      <div className={styles.avatar}>
        {/* <span
          className={classNames({
            [styles.cover]: true,
            [styles.online]: data.is_online
          })}
        ></span> */}
        {data.is_online ? <span className={styles.circle}></span> : null}
        <Image src={data.avatar} alt='' />
      </div>
      <div className={styles.info}>
        <p>
          <span className={styles.name}>{data.full_name}</span>
        </p>
        <p>
          <span>{data.job_title}</span>
          {data.job_title && data.company_name ? (
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='3'
              height='4'
              viewBox='0 0 3 4'
              fill='none'
            >
              <circle cx='1.25' cy='2' r='1.25' fill='#7D7D7D' />
            </svg>
          ) : null}
          <span>{data.company_name}</span>
        </p>
        <p>
          <span>{data.reply_label}</span>
        </p>
      </div>
    </div>
  );

  // return null;
};

export default Recruiter;
